import React from 'react'
import Head from 'next/head'

import { IntercomProvider } from 'react-use-intercom'
import UserSessionProvider from '../reason/common/UserSession/UserSessionProvider'
import App from '../pagesComponents/App'
import smoothscroll from 'smoothscroll-polyfill'
import '../stylesheets/app.scss'
import '../stylesheets/globals.css'
import '@topagentnetwork/registration-ui/style.css'
import '../stylesheets/auth-ui-tan-skin.css'
import { make as IntercomHandler } from '../IntercomSessionHandler.bs'
import QueryParamsProvider from '../components/QueryParamsProvider'
import { make as PathHistoryProvider } from '../reason/PathHistory.bs'
import PageTitle from '../v5/common/Components/PageTitle.bs'
import { RelayEnvironmentProvider } from 'react-relay/hooks'
import { environment as relayEnvironment } from '../RelayEnv.bs'
import { make as SocketStatus } from '../GraphQLWSClient.bs'
import Loader from 'v5/common/Components/Loader.bs'
import { useRouter } from 'next/router'
import { make as SessionRenewer } from '../utils/SessionRenewer.bs'
const { RouterProvider } = require('react-aria-components')

if (typeof window !== 'undefined') {
  smoothscroll.polyfill()
}

import '../reason/clients/components/searchComponents.css'

const intercomAppId = process.env.NEXT_PUBLIC_INTERCOM_APP_ID

function MyApp({ Component, pageProps, err }) {
  const getLayout = Component.getLayout || (page => page)
  const page = getLayout(<Component {...pageProps} err={err} />)
  let router = useRouter()

  return (
    <>
      <Head>
        {/* Keep mobile viewport scale explicit. iOS otherwise falls back to Next's width-only default. */}
        <meta name="viewport" content="width=device-width, initial-scale=1" key="viewport" />
      </Head>
      <PageTitle title="TAN: The only online network built exclusively for verified top agents" />
      <IntercomProvider appId={intercomAppId}>
        <UserSessionProvider>
          <QueryParamsProvider>
            <PathHistoryProvider>
              <RelayEnvironmentProvider environment={relayEnvironment}>
                <IntercomHandler />
                <RouterProvider
                  navigate={(href, opts) => {
                    router.push(href, undefined, opts)
                  }}
                  useHref={href => router.basePath + href}
                >
                  <React.Suspense fallback={<Loader />}>
                    <SocketStatus />
                    <SessionRenewer />
                    <App>{page}</App>
                  </React.Suspense>
                </RouterProvider>
              </RelayEnvironmentProvider>
            </PathHistoryProvider>
          </QueryParamsProvider>
        </UserSessionProvider>
      </IntercomProvider>
    </>
  )
}

export default MyApp
